var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-dim flex-col"},[_c('div',{staticClass:"safe-area absolute"},[_vm._m(0),_c('div',{staticClass:"button-wrap"},[_c('button',{staticClass:"button-bg-gray",on:{"click":function($event){return _vm.$router.go(-2);}}},[_vm._v("닫기")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-wrap"},[_c('div',[_c('span',[_vm._v("구매취소되었습니다")])])])
}]

export { render, staticRenderFns }